export default __webpack_public_path__ + "static/media/rocket.78437463.webp";